import { jsxs as t, jsx as r, Fragment as L } from "react/jsx-runtime";
import { useRef as P, useEffect as E } from "react";
import "dayjs";
import { useTranslation as A } from "react-i18next";
import "../../../../../contexts/global-context.js";
import "motion/react";
import { OutlineIconButton as O } from "../../../../../components/elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import i from "./select-time-slot-and-personal-info.module.less.js";
import { PersonalInformation as g } from "../personal-information/personal-information.js";
import { SelectTimeSlotForTrailer as v } from "../select-time-slot-for-trailer/select-time-slot-for-trailer.js";
import { useGetTrailerRentalPrice as b } from "../../../react-query-queries/use-get-trailer-rental-price.js";
import M, { SkeletonTheme as Y } from "react-loading-skeleton";
/* empty css                                                                   */
const z = ({
  dispatch: p,
  step: o,
  selectedTrailer: s,
  selectedStation: c,
  selectedRentalStartDate: h,
  selectedRentalEndDate: T,
  selectedFromSlot: n,
  selectedToSlot: a,
  closeDrawer: d,
  rentalTermsLinkUrl: f,
  personalInformationForm: I
}) => {
  const { t: e } = A(), u = e(o === "SELECT_TIMESLOT_FOR_TRAILER" ? "TRAILER_RENTAL_RESERVE_TRAILER" : "PERSONAL_INFORMATION"), m = P(null), {
    data: l,
    isLoading: N,
    refetch: _
  } = b({
    locationId: c.locationId,
    typeId: s.trailerTypeId,
    pickupTime: n ? n.format("YYYY-MM-DD HH:mm") : "",
    returnTime: a ? a.format("YYYY-MM-DD HH:mm") : ""
  });
  E(() => {
    n && a && _();
  }, [n, a]), E(() => {
    m && m.current && (m.current.scrollTop = 0);
  }, [o]);
  const R = n && a, C = () => {
    if (o === "SELECT_TIMESLOT_FOR_TRAILER")
      return /* @__PURE__ */ r(
        v,
        {
          closeDrawer: d,
          dispatch: p,
          trailer: s,
          station: c,
          rentalStartDate: h,
          rentalEndDate: T,
          selectedFromSlot: n,
          selectedToSlot: a,
          rentalPrice: l?.totalPrice
        }
      );
    if (o === "PERSONAL_INFORMATION")
      return n && a && /* @__PURE__ */ r(
        g,
        {
          dispatch: p,
          station: c,
          trailer: s,
          fromSlot: n,
          toSlot: a,
          rentalPrice: l?.totalPrice,
          rentalTermsLinkUrl: f,
          personalInformationForm: I
        }
      );
  };
  return /* @__PURE__ */ t("div", { className: i.wrapper, ref: m, children: [
    /* @__PURE__ */ r("div", { className: [i.innerWrapper, "max-width padded-sides centered"].join(" "), children: /* @__PURE__ */ t("div", { className: i.stepContent, children: [
      /* @__PURE__ */ t("div", { className: i.stepHeadingWrapper, children: [
        /* @__PURE__ */ r("h3", { children: u }),
        /* @__PURE__ */ r(O, { icon: "ui-icon-close", onClick: d })
      ] }),
      C()
    ] }) }),
    /* @__PURE__ */ r("div", { className: i.summary, children: /* @__PURE__ */ r("div", { className: [i.summaryInnerWrapper, "max-width padded-sides centered"].join(" "), children: /* @__PURE__ */ t("div", { className: i.priceWrapper, children: [
      R && /* @__PURE__ */ r(L, { children: /* @__PURE__ */ t("span", { className: [i.brandColorTitle, "h5"].join(" "), children: [
        e("PRICE"),
        ":",
        !N && l?.totalPrice ? ` ${l.totalPrice} ${e("SEK_CURRENCY")}` : /* @__PURE__ */ r(
          Y,
          {
            borderRadius: "var(--core-border-radius-default)",
            baseColor: "var(--ctx-skeleton-loader-background",
            highlightColor: "var(--ctx-skeleton-loader-highlights)",
            children: /* @__PURE__ */ r(M, { duration: 1.6, width: 70, containerClassName: i.skeletonContainer })
          }
        )
      ] }) }),
      !R && /* @__PURE__ */ r("span", { className: [i.brandColorTitle, "h5"].join(" "), children: e("TRAILER_RENTAL_SELECT_TIMESLOT_FOR_PRICE") }),
      /* @__PURE__ */ r("span", { className: [i.brandColorTitle, "body-s"].join(" "), children: e("TRAILER_RENTAL_PRICE_REDUCTION_INCLUDED") })
    ] }) }) })
  ] });
};
export {
  z as SelectTimeSlotAndPersonalInfo,
  z as default
};
